import React, { RefObject } from 'react';
import { TextArrowLink } from '../../../components';
import { useScrollReveal } from '../../../hooks';
import { SectionHeader } from '../../../sections/ThesisSection/layouts';
import { LINKS, MODELS } from '../content';
import { SizeNest } from '../figures/SizeNest';
import { AFTER_FADE, usePlayOnce } from '../motion';
import { rich } from '../rich';
import { Band, reveal } from './Band';

export function ModelsSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });
  const [row, stage] = usePlayOnce<HTMLDivElement>();
  return (
    <Band id="models" tone="secondary">
      <div ref={ref as RefObject<HTMLDivElement>}>
        <SectionHeader
          label="The kettei models"
          title="Four sizes. Two of them are open."
          description={rich('*kettei fat*, *chub* and *core* share one API, so you can switch sizes without touching your code. *fat* and *chub* are multimodal.')}
          isVisible={isVisible}
          labelColor="ink"
        />

        <div className={`oh-section-link ${reveal(isVisible)}`} style={{ animationDelay: '0.2s' }}>
          <TextArrowLink href={LINKS.announcement}>See the benchmarks</TextArrowLink>
        </div>

        <div ref={row} className="oh-models grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {MODELS.map((model, i) => (
            <div key={model.id} className={`oh-model ${reveal(isVisible)}`} style={{ animationDelay: `${0.25 + i * 0.08}s` }}>
              <div className="oh-model-nest">
                <SizeNest index={i} stage={stage} delay={AFTER_FADE + i * 0.12} />
              </div>
              <div className="oh-model-body">
                <h3 className="font-display italic text-heading text-foreground">{model.name}</h3>
                <p className="mt-1 font-mono text-[12px] text-foreground-muted">{model.id}</p>
                <ul className="mt-4 grid gap-1 font-body text-body-sm text-foreground-tertiary">
                  <li>{model.sees}</li>
                  {model.price && (
                    <li><span className="font-mono text-[13px] text-foreground-secondary dark:text-white/70">{model.price}</span> per million input tokens</li>
                  )}
                  {model.tuning && <li>{model.tuning}</li>}
                </ul>
                {model.weights && (
                  <a href={model.weights.href} target="_blank" rel="noopener noreferrer" className="oh-open">
                    Open weights, {model.weights.size} <span aria-hidden="true">↗</span>
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Band>
  );
}

export default ModelsSection;
